export const DatevExportType = Object.freeze({
  invoices: 'invoices',
  expenses: 'expenses',
  bankBookings: 'bankBookings',
  customersVendors: 'customersVendors',
})
